import { makeObservable } from 'mobx';
import { Common } from 'src/AppState/Common';
import { CampaignModel } from 'src/domains/casino/state/AppCasino/store/campaign-store/CampaignModel';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Resource } from 'src_common/common/mobx-utils/Resource';

export interface ErrorCampaignModelType {
    message: string;
    status: string;
}

export type CampaignModelType =
    | {
          status: 'success';
          body: CampaignModel;
      }
    | {
          status: 'error';
          body: string;
      };

export class SingleCampaignStore {
    public static get = AutoWeakMap.create(
        (common: Common, campaignId: string) => new SingleCampaignStore(common, campaignId)
    );

    private readonly campaignResource: Resource<CampaignModelType>;

    public constructor(
        private readonly common: Common,
        private readonly campaignId: string
    ) {
        makeObservable(this);

        this.campaignResource = new Resource(async (): Promise<CampaignModelType> => {
            try {
                const response = await this.common.trpcClient.client.bonusCampaignsRouter.getCampaign.mutate({
                    id: this.campaignId,
                });
                if (response.status === 200) {
                    return {
                        status: 'success',
                        body: new CampaignModel(response.body),
                    };
                }
                if (response.status === 404) {
                    return {
                        body: response.body.message,
                        status: 'error',
                    };
                }

                console.error(`Unexpected http response`, response);
            } catch (error) {
                console.error('Error fetching campaign:', error);
            }

            return {
                body: 'Error occured',
                status: 'error',
            };
        });
    }

    public get campaignModel(): CampaignModelType | 'loading' {
        const data = this.campaignResource.get();
        if (data.type === 'loading') {
            return 'loading';
        }

        if (data.type === 'ready') {
            return data.value;
        }

        return {
            body: 'Error occured',
            status: 'error',
        };
    }
}
